import React from 'react';
import { rst } from 'rt-state';
import { makeStyles } from '@material-ui/core/styles';
import { FirstPageHead } from '../Home/components/FirstPageHead';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { formatDate, SecurityProvider, TR } from '../../commons';
import { Container, Hidden, Link } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { isSameDay } from 'date-fns';
import { getPropertyReports } from '../../services/userCenter';
import { Arrays } from '../../commons/array';
import Grid from '@material-ui/core/Grid';
import i18next from 'i18next';
import { PropertyReportDto } from '../../models/backend/userCenter/PropertyReportDto';
import { api_getReportLink } from '../../services/property';
import { useHistory } from 'react-router-dom';
import { APIResponse } from '../../models/APIResponse';
import { NewHomePageHead } from '../NewHome/components/01NewHomePageHead';
import { NewHomeFooter } from '../NewHome/components/11NewHomeFooter';
import { NewHomeFooterForMobile } from '../NewHome/components/11NewHomeFooterForMobile';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(2),
        maxWidth: 780,
        minHeight: '70vh',
        backgroundColor: 'white',
        margin: '0 auto',
    },
    dummy: {},
}));

export const MyPropertyReportsPage = rst.create((ctx) => {
    const state = rst.stateS<APIResponse<PropertyReportDto>>(null);
    const securityProvider = SecurityProvider.use();
    getPropertyReports(0, 1000).then((data) => {
        state.value = data;
    });

    return (props) => {
        const totalCount = state.value?.totalCount ?? 0;
        const leftReports = securityProvider.getUserProfile()?.reportCountProperty ?? 0;
        const classes = useStyles();
        let previousDate = null;
        let currDate = null;

        let historyNode;
        if (Arrays.hasItems(state.value?.items)) {
            historyNode = state.value?.items?.map((dto) => {
                previousDate = currDate;
                currDate = dto.createTime;
                return <MyPropertyReportItem previousDate={previousDate} key={dto.id} dto={dto} />;
            });
        } else {
            historyNode = (
                <Grid container justify={'center'}>
                    <TR name={'No property reports'} />
                </Grid>
            );
        }
        return (
            // <div className={classes.zIndex}>
            <div>
                <NewHomePageHead />
                <Container className={classes.container}>
                    <div>
                        <TR name={'Viewed'} />: {totalCount}, <TR name={'Left'} />: {leftReports}
                    </div>
                    {historyNode}
                </Container>
                <Hidden smDown>
                    <NewHomeFooter />
                </Hidden>
                <Hidden mdUp>
                    <NewHomeFooterForMobile />
                </Hidden>
            </div>
        );
    };
});

const MyPropertyReportItem = rst.create<{ previousDate: Date; dto: PropertyReportDto }>((ctx) => {
    const hooksRef = rst.hooks(useHistory);
    async function openReportLink(propId: string) {
        const url = await api_getReportLink(propId);
        hooksRef.current.push(url);
    }

    return (props) => {
        useTranslation();
        const lan = i18next.language;
        const { dto, previousDate } = props;
        const address = dto.entity?.stdAddress;
        const hide = isSameDay(previousDate, dto.createTime);

        return (
            <>
                {hide || (
                    <Box mr={1} mt={1}>
                        <Typography>{formatDate(dto.createTime, 'yyyy.MM.dd HH:mm eeee')}</Typography>
                    </Box>
                )}

                <Box px={{ xs: 1, sm: 2, md: 4 }} pt={1} display={'flex'} flexDirection={'row'}>
                    <Box flexGrow={1} display={'flex'} justifyContent={'flex-start'}>
                        <Link
                            onClick={async () => {
                                await openReportLink(props.dto.entity.id);
                            }}
                            color="initial"
                            style={{ textDecoration: 'none' }}>
                            <Typography align={'left'}>{address}</Typography>
                        </Link>
                    </Box>
                </Box>
            </>
        );
    };
});
